import { css } from '@emotion/react';
import { type ForwardedRef, forwardRef, type HTMLProps, memo } from 'react';

export type AudioPlayerProps = Omit<HTMLProps<HTMLAudioElement>, 'ref'> & {
  /** NOT STANDARD, only works on Chromium-based browsers. */
  controlsList?: string;
};

export const AudioPlayerBase = forwardRef(
  (
    {
      src,
      controls = true,
      controlsList = 'nodownload noplaybackrate',
      ...props
    }: AudioPlayerProps,
    ref: ForwardedRef<HTMLAudioElement>,
  ) => (
    <audio
      {...props}
      src={src}
      controls={controls}
      controlsList={controlsList}
      ref={ref}
      css={css`
        width: 100%;
        min-width: 185px;
        display: block;
      `}
    />
  ),
);

AudioPlayerBase.displayName = 'AudioPlayer';

export const AudioPlayer = memo(AudioPlayerBase);
